import React from 'react';
import { Skeleton } from '@mui/material';
import { TeamName, TeamNames, TeamResult, Wrapper } from 'app/components/matchRow/teaser/teaserStyles';
import styled from 'styled-components';
import { SIZES } from '@fupa/fupa-uikit';
const Container = styled.div.withConfig({
  componentId: "sc-xonxn-0"
})(["display:flex;justify-content:space-between;max-width:", ";width:", ";"], SIZES['46'], SIZES['46']);
export default function MatchRowTeaserSkeleton(_ref) {
  let {
    animation
  } = _ref;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "MatchRowTeaserSkeleton",
    "data-sentry-source-file": "MatchRowTeaserSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(TeamResult, {
    "data-sentry-element": "TeamResult",
    "data-sentry-source-file": "MatchRowTeaserSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "circular",
    width: 32,
    height: 32,
    animation: animation,
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "MatchRowTeaserSkeleton.tsx"
  }), /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-source-file": "MatchRowTeaserSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "rounded",
    width: 22,
    height: 30,
    animation: animation,
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "MatchRowTeaserSkeleton.tsx"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    variant: "rounded",
    width: 22,
    height: 30,
    animation: animation,
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "MatchRowTeaserSkeleton.tsx"
  })), /*#__PURE__*/React.createElement(Skeleton, {
    variant: "circular",
    width: 32,
    height: 32,
    animation: animation,
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "MatchRowTeaserSkeleton.tsx"
  })), /*#__PURE__*/React.createElement(TeamNames, {
    "data-sentry-element": "TeamNames",
    "data-sentry-source-file": "MatchRowTeaserSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: animation,
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "MatchRowTeaserSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(TeamName, {
    variant: "caption1",
    "data-sentry-element": "TeamName",
    "data-sentry-source-file": "MatchRowTeaserSkeleton.tsx"
  }, "Teamname 1")), /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: animation,
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "MatchRowTeaserSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(TeamName, {
    variant: "caption1",
    "data-sentry-element": "TeamName",
    "data-sentry-source-file": "MatchRowTeaserSkeleton.tsx"
  }, "Teamname 2"))));
}